import axios from 'axios';
import { apiBaseUrl } from '../config';

// ── Helpers ───────────────────────────────────────────────────────────────────

function authHeaders(token) {
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

const opts = (token) => ({ headers: authHeaders(token), withCredentials: true });

// ── Tool Subscription ─────────────────────────────────────────────────────────

export function createToolPaymentOrder(token, toolId) {
  return axios.post(`${apiBaseUrl}/user/payment/order`, { payment_type: 'tool', payment_type_id: toolId }, opts(token));
}

export function verifyToolPayment(token, payload) {
  return axios.post(`${apiBaseUrl}/user/payment/verify`, payload, opts(token));
}

// ── Paper Trading Account ─────────────────────────────────────────────────────

export function createPaperAccount(token) {
  return axios.post(`${apiBaseUrl}/papertrading/account`, {}, opts(token));
}

export function getPaperAccount(token) {
  return axios.get(`${apiBaseUrl}/papertrading/account`, opts(token));
}

// ── Orders ────────────────────────────────────────────────────────────────────

export function placeOrder(token, payload) {
  // payload: { symbol, side, quantity, order_type }
  return axios.post(`${apiBaseUrl}/papertrading/orders`, payload, opts(token));
}

export function listOrders(token, params = {}) {
  return axios.get(`${apiBaseUrl}/papertrading/orders`, { ...opts(token), params });
}

export function cancelOrder(token, orderId) {
  return axios.delete(`${apiBaseUrl}/papertrading/orders/${orderId}`, opts(token));
}

// ── Positions ─────────────────────────────────────────────────────────────────

export function getPositions(token) {
  return axios.get(`${apiBaseUrl}/papertrading/positions`, opts(token));
}

// ── Portfolio ─────────────────────────────────────────────────────────────────

export function getPortfolio(token) {
  return axios.get(`${apiBaseUrl}/papertrading/portfolio`, opts(token));
}

export function getPortfolioHistory(token, limit = 30) {
  return axios.get(`${apiBaseUrl}/papertrading/portfolio/history`, { ...opts(token), params: { limit } });
}

// ── Risk Management (PTRMS) ─────────────────────────────────────────────────────

export function getRiskRules(token) {
  return axios.get(`${apiBaseUrl}/papertrading/riskrules`, opts(token));
}

export function updateRiskRules(token, payload) {
  // payload: { max_account_risk_pct, max_daily_loss_limit, max_trades_per_day,
  //            max_position_size, enforce_hard_liquidation, rule_lock_duration_hours }
  return axios.put(`${apiBaseUrl}/papertrading/riskrules`, payload, opts(token));
}

// ── Watchlist ─────────────────────────────────────────────────────────────────

export function getWatchlist(token) {
  return axios.get(`${apiBaseUrl}/papertrading/watchlist`, opts(token));
}

export function addToWatchlist(token, symbol) {
  return axios.post(`${apiBaseUrl}/papertrading/watchlist`, { symbol }, opts(token));
}

export function removeFromWatchlist(token, symbol) {
  return axios.delete(`${apiBaseUrl}/papertrading/watchlist/${symbol}`, opts(token));
}

// ── Market Data (require auth) ────────────────────────────────────────────────

export function getQuotes(token, symbols) {
  const symbolList = Array.isArray(symbols) ? symbols.join(',') : symbols;
  return axios.get(`${apiBaseUrl}/marketdata/quotes`, {
    ...opts(token),
    params: { symbols: symbolList },
  });
}
